module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/fridge-a0714568dc059f30880378610babb447.svg";